import Vue from "vue";
import Vant from "vant";
import "vant/lib/index.css";
import "@/styles/demo-base.scss";
import "@/styles/richtext.scss";
import App from "./App.vue";
import router from "./router";
import { handleWxAuthReturn, popReturnRoute } from "@/utils/wxAuth.js";
import { initTracking } from "@/utils/logTracking.js";
import "@/utils/trackDirective.js";

Vue.use(Vant);
Vue.config.productionTip = false;

// 记渠道来源(?source=xxx)和生成匿名用户UUID，越早越好，App正式挂载前先做完
initTracking();

// App启动第一件事：看看是不是刚从微信授权跳转回来的(地址栏上有没有code)，
// 有的话先把openId换出来存好，再把用户带回授权前记下来的那个页面
handleWxAuthReturn().then((handled) => {
  new Vue({
    router,
    render: (h) => h(App),
  }).$mount("#app");

  if (handled) {
    let returnRoute = popReturnRoute();
    if (returnRoute) {
      router.replace(returnRoute).catch(() => {});
    }
  }
});
